/**
 * Multi-lingual translations for audio diagnostic UI
 */

export const AUDIO_DIAGNOSTIC_TRANSLATIONS = {
  en: {
    // Speech bubble messages
    listenAndRepeat: "Hi! Listen to the audio and repeat it!",
    nowRepeat: "Now repeat what you heard!",
    keepSpeaking: "Great! Keep speaking...",
    micTestPassed: "Awesome! You did great!",
    testMicrophone: "Let's test your microphone!",
    listenToVoice: "Now let's listen to your voice!",
    canYouHear: "Can you hear it?",
    speakerTestPassed: "Perfect! You're all set!",
    testSpeakers: "Let's test your speakers!",

    // Button labels
    clickToListen: "Click to listen",
    clickToListenAgain: "Click to listen again",
    playingAudio: "Playing audio...",
    repeatNow: "REPEAT NOW",
    tryAgain: "TRY AGAIN",
    continue: "CONTINUE",
    skip: "Skip",

    // Error messages
    micErrorNoAudio: "We can't hear you! Check if your microphone is on.",
    micErrorMuted: "We can't hear you! Make sure your microphone is on.",
    micErrorPermission:
      "We need permission to hear you! Please allow microphone access.",
    micErrorGeneric: "Something went wrong. Please try again!",
    speakerError: "We couldn't play the sound! Check if your speakers are on!",
    speakerErrorGeneric: "Oops! The sound didn't play. Try again!",
    speakerErrorNoTest:
      "We couldn't test your speakers. Make sure they're turned on!",

    // Success messages
    allTestsPassed: "All tests passed! You're ready to start learning!",
  },
  hi: {
    // Speech bubble messages
    listenAndRepeat: "नमस्ते! ऑडियो सुनें और दोहराएं!",
    nowRepeat: "अब जो आपने सुना, उसे दोहराएं!",
    keepSpeaking: "बहुत बढ़िया! बोलते रहें...",
    micTestPassed: "शानदार! आपने बहुत अच्छा किया!",
    testMicrophone: "आइए अपने माइक्रोफोन का परीक्षण करें!",
    listenToVoice: "अब आइए अपनी आवाज़ सुनें!",
    canYouHear: "क्या आप इसे सुन सकते हैं?",
    speakerTestPassed: "बिल्कुल सही! आप तैयार हैं!",
    testSpeakers: "आइए अपने स्पीकर का परीक्षण करें!",

    // Button labels
    clickToListen: "सुनने के लिए क्लिक करें",
    clickToListenAgain: "फिर से सुनने के लिए क्लिक करें",
    playingAudio: "ऑडियो चल रहा है...",
    repeatNow: "अभी दोहराएं",
    tryAgain: "फिर से कोशिश करें",
    continue: "जारी रखें",
    skip: "छोड़ें",

    // Error messages
    micErrorNoAudio:
      "हम आपकी आवाज़ नहीं सुन सकते! जांचें कि क्या आपका माइक्रोफोन चालू है।",
    micErrorMuted:
      "हम आपकी आवाज़ नहीं सुन सकते! सुनिश्चित करें कि आपका माइक्रोफोन चालू है।",
    micErrorPermission:
      "हमें आपकी आवाज़ सुनने की अनुमति चाहिए! कृपया माइक्रोफोन पहुंच की अनुमति दें।",
    micErrorGeneric: "कुछ गलत हो गया। कृपया फिर से कोशिश करें!",
    speakerError: "हम ध्वनि नहीं बजा सके! जांचें कि क्या आपके स्पीकर चालू हैं!",
    speakerErrorGeneric: "ओह! ध्वनि नहीं बजी। फिर से कोशिश करें!",
    speakerErrorNoTest:
      "हम आपके स्पीकर का परीक्षण नहीं कर सके। सुनिश्चित करें कि वे चालू हैं!",

    // Success messages
    allTestsPassed: "सभी परीक्षण पास! आप सीखना शुरू करने के लिए तैयार हैं!",
  },
  ta: {
    // Speech bubble messages
    listenAndRepeat: "வணக்கம்! ஆடியோவைக் கேட்டு மீண்டும் சொல்லுங்கள்!",
    nowRepeat: "இப்போது நீங்கள் கேட்டதை மீண்டும் சொல்லுங்கள்!",
    keepSpeaking: "நன்றாக! தொடர்ந்து பேசுங்கள்...",
    micTestPassed: "அருமை! நீங்கள் நன்றாக செய்தீர்கள்!",
    testMicrophone: "உங்கள் மைக்ரோஃபோனை சோதிக்கலாம்!",
    listenToVoice: "இப்போது உங்கள் குரலைக் கேட்போம்!",
    canYouHear: "நீங்கள் கேட்க முடிகிறதா?",
    speakerTestPassed: "சரியாக! நீங்கள் தயார்!",
    testSpeakers: "உங்கள் ஸ்பீக்கர்களை சோதிக்கலாம்!",

    // Button labels
    clickToListen: "கேட்க கிளிக் செய்யவும்",
    clickToListenAgain: "மீண்டும் கேட்க கிளிக் செய்யவும்",
    playingAudio: "ஆடியோ இயங்குகிறது...",
    repeatNow: "இப்போது மீண்டும் சொல்லுங்கள்",
    tryAgain: "மீண்டும் முயற்சிக்கவும்",
    continue: "தொடரவும்",
    skip: "தவிர்க்கவும்",

    // Error messages
    micErrorNoAudio:
      "உங்கள் குரலை நாங்கள் கேட்க முடியவில்லை! உங்கள் மைக்ரோஃபோன் இயக்கத்தில் உள்ளதா என்பதைச் சரிபார்க்கவும்।",
    micErrorMuted:
      "உங்கள் குரலை நாங்கள் கேட்க முடியவில்லை! உங்கள் மைக்ரோஃபோன் இயக்கத்தில் உள்ளது என்பதை உறுதிப்படுத்தவும்।",
    micErrorPermission:
      "உங்களைக் கேட்க எங்களுக்கு அனுமதி தேவை! தயவுசெய்து மைக்ரோஃபோன் அணுகலை அனுமதிக்கவும்।",
    micErrorGeneric: "ஏதோ தவறு நடந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
    speakerError:
      "ஒலியை இயக்க முடியவில்லை! உங்கள் ஸ்பீக்கர்கள் இயக்கத்தில் உள்ளதா என்பதைச் சரிபார்க்கவும்!",
    speakerErrorGeneric: "ஓ! ஒலி இயங்கவில்லை. மீண்டும் முயற்சிக்கவும்!",
    speakerErrorNoTest:
      "உங்கள் ஸ்பீக்கர்களை நாங்கள் சோதிக்க முடியவில்லை. அவை இயக்கத்தில் உள்ளதா என்பதை உறுதிப்படுத்தவும்!",

    // Success messages
    allTestsPassed:
      "அனைத்து சோதனைகளும் தேர்ச்சி! நீங்கள் கற்றுக்கொள்ளத் தயார்!",
  },
  te: {
    // Speech bubble messages
    listenAndRepeat: "హాయ్! ఆడియో విని మళ్లీ చెప్పండి!",
    nowRepeat: "ఇప్పుడు మీరు విన్నదాన్ని మళ్లీ చెప్పండి!",
    keepSpeaking: "బాగుంది! మాట్లాడుతూ ఉండండి...",
    micTestPassed: "అద్భుతం! మీరు చాలా బాగా చేసారు!",
    testMicrophone: "మీ మైక్రోఫోన్ను పరీక్షిద్దాం!",
    listenToVoice: "ఇప్పుడు మీ స్వరాన్ని వినండి!",
    canYouHear: "మీరు వినగలరా?",
    speakerTestPassed: "పర్ఫెక్ట్! మీరు సిద్ధంగా ఉన్నారు!",
    testSpeakers: "మీ స్పీకర్లను పరీక్షిద్దాం!",

    // Button labels
    clickToListen: "వినడానికి క్లిక్ చేయండి",
    clickToListenAgain: "మళ్లీ వినడానికి క్లిక్ చేయండి",
    playingAudio: "ఆడియో ప్లే అవుతోంది...",
    repeatNow: "ఇప్పుడు మళ్లీ చెప్పండి",
    tryAgain: "మళ్లీ ప్రయత్నించండి",
    continue: "కొనసాగించండి",
    skip: "దాటవేయి",

    // Error messages
    micErrorNoAudio:
      "మేము మీ స్వరాన్ని వినలేము! మీ మైక్రోఫోన్ ఆన్ ఉందో లేదో తనిఖీ చేయండి.",
    micErrorMuted:
      "మేము మీ స్వరాన్ని వినలేము! మీ మైక్రోఫోన్ ఆన్ ఉందని నిర్ధారించుకోండి.",
    micErrorPermission:
      "మీరిని వినడానికి మాకు అనుమతి కావాలి! దయచేసి మైక్రోఫోన్ ప్రాప్యతను అనుమతించండి.",
    micErrorGeneric: "ఏదో తప్పు జరిగింది. దయచేసి మళ్లీ ప్రయత్నించండి!",
    speakerError:
      "మేము ధ్వనిని ప్లే చేయలేకపోయాము! మీ స్పీకర్లు ఆన్ ఉన్నాయో లేదో తనిఖీ చేయండి!",
    speakerErrorGeneric: "ఓహ్! ధ్వని ప్లే కాలేదు. మళ్లీ ప్రయత్నించండి!",
    speakerErrorNoTest:
      "మేము మీ స్పీకర్లను పరీక్షించలేకపోయాము. అవి ఆన్ అయ్యాయో లేదో నిర్ధారించుకోండి!",

    // Success messages
    allTestsPassed:
      "అన్ని పరీక్షలు పాస్! మీరు నేర్చుకోవడానికి సిద్ధంగా ఉన్నారు!",
  },
  ka: {
    // Speech bubble messages
    listenAndRepeat: "ನಮಸ್ಕಾರ! ಆಡಿಯೋವನ್ನು ಕೇಳಿ ಮತ್ತು ಪುನರಾವರ್ತಿಸಿ!",
    nowRepeat: "ಈಗ ನೀವು ಕೇಳಿದ್ದನ್ನು ಪುನರಾವರ್ತಿಸಿ!",
    keepSpeaking: "ಉತ್ತಮ! ಮಾತನಾಡುತ್ತಲೇ ಇರಿ...",
    micTestPassed: "ಅದ್ಭುತ! ನೀವು ಚೆನ್ನಾಗಿ ಮಾಡಿದ್ದೀರಿ!",
    testMicrophone: "ನಿಮ್ಮ ಮೈಕ್ರೋಫೋನ್ ಅನ್ನು ಪರೀಕ್ಷಿಸೋಣ!",
    listenToVoice: "ಈಗ ನಿಮ್ಮ ಧ್ವನಿಯನ್ನು ಕೇಳೋಣ!",
    canYouHear: "ನೀವು ಕೇಳಬಲ್ಲಿರಾ?",
    speakerTestPassed: "ಪರಿಪೂರ್ಣ! ನೀವು ಸಿದ್ಧರಾಗಿದ್ದೀರಿ!",
    testSpeakers: "ನಿಮ್ಮ ಸ್ಪೀಕರ್ಗಳನ್ನು ಪರೀಕ್ಷಿಸೋಣ!",

    // Button labels
    clickToListen: "ಕೇಳಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
    clickToListenAgain: "ಮತ್ತೆ ಕೇಳಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
    playingAudio: "ಆಡಿಯೋ ಪ್ಲೇ ಆಗುತ್ತಿದೆ...",
    repeatNow: "ಈಗ ಪುನರಾವರ್ತಿಸಿ",
    tryAgain: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    continue: "ಮುಂದುವರಿಸಿ",
    skip: "ಬಿಟ್ಟುಬಿಡಿ",

    // Error messages
    micErrorNoAudio:
      "ನಾವು ನಿಮ್ಮ ಧ್ವನಿಯನ್ನು ಕೇಳಲು ಸಾಧ್ಯವಿಲ್ಲ! ನಿಮ್ಮ ಮೈಕ್ರೋಫೋನ್ ಆನ್ ಆಗಿದೆಯೇ ಎಂದು ಪರಿಶೀಲಿಸಿ.",
    micErrorMuted:
      "ನಾವು ನಿಮ್ಮ ಧ್ವನಿಯನ್ನು ಕೇಳಲು ಸಾಧ್ಯವಿಲ್ಲ! ನಿಮ್ಮ ಮೈಕ್ರೋಫೋನ್ ಆನ್ ಆಗಿದೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.",
    micErrorPermission:
      "ನಿಮ್ಮನ್ನು ಕೇಳಲು ನಮಗೆ ಅನುಮತಿ ಬೇಕು! ದಯವಿಟ್ಟು ಮೈಕ್ರೋಫೋನ್ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ.",
    micErrorGeneric: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ!",
    speakerError:
      "ನಾವು ಧ್ವನಿಯನ್ನು ಪ್ಲೇ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ! ನಿಮ್ಮ ಸ್ಪೀಕರ್ಗಳು ಆನ್ ಆಗಿದೆಯೇ ಎಂದು ಪರಿಶೀಲಿಸಿ!",
    speakerErrorGeneric: "ಓಹ್! ಧ್ವನಿ ಪ್ಲೇ ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ!",
    speakerErrorNoTest:
      "ನಾವು ನಿಮ್ಮ ಸ್ಪೀಕರ್ಗಳನ್ನು ಪರೀಕ್ಷಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ. ಅವು ಆನ್ ಆಗಿದೆಯೇ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ!",

    // Success messages
    allTestsPassed: "ಎಲ್ಲಾ ಪರೀಕ್ಷೆಗಳು ಪಾಸ್! ನೀವು ಕಲಿಯಲು ಸಿದ್ಧರಾಗಿದ್ದೀರಿ!",
  },
  kn: {
    // Same as Kannada (ka)
    listenAndRepeat: "ನಮಸ್ಕಾರ! ಆಡಿಯೋವನ್ನು ಕೇಳಿ ಮತ್ತು ಪುನರಾವರ್ತಿಸಿ!",
    nowRepeat: "ಈಗ ನೀವು ಕೇಳಿದ್ದನ್ನು ಪುನರಾವರ್ತಿಸಿ!",
    keepSpeaking: "ಉತ್ತಮ! ಮಾತನಾಡುತ್ತಲೇ ಇರಿ...",
    micTestPassed: "ಅದ್ಭುತ! ನೀವು ಚೆನ್ನಾಗಿ ಮಾಡಿದ್ದೀರಿ!",
    testMicrophone: "ನಿಮ್ಮ ಮೈಕ್ರೋಫೋನ್ ಅನ್ನು ಪರೀಕ್ಷಿಸೋಣ!",
    listenToVoice: "ಈಗ ನಿಮ್ಮ ಧ್ವನಿಯನ್ನು ಕೇಳೋಣ!",
    canYouHear: "ನೀವು ಕೇಳಬಲ್ಲಿರಾ?",
    speakerTestPassed: "ಪರಿಪೂರ್ಣ! ನೀವು ಸಿದ್ಧರಾಗಿದ್ದೀರಿ!",
    testSpeakers: "ನಿಮ್ಮ ಸ್ಪೀಕರ್ಗಳನ್ನು ಪರೀಕ್ಷಿಸೋಣ!",
    clickToListen: "ಕೇಳಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
    clickToListenAgain: "ಮತ್ತೆ ಕೇಳಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
    playingAudio: "ಆಡಿಯೋ ಪ್ಲೇ ಆಗುತ್ತಿದೆ...",
    repeatNow: "ಈಗ ಪುನರಾವರ್ತಿಸಿ",
    tryAgain: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    continue: "ಮುಂದುವರಿಸಿ",
    skip: "ಬಿಟ್ಟುಬಿಡಿ",
    micErrorNoAudio:
      "ನಾವು ನಿಮ್ಮ ಧ್ವನಿಯನ್ನು ಕೇಳಲು ಸಾಧ್ಯವಿಲ್ಲ! ನಿಮ್ಮ ಮೈಕ್ರೋಫೋನ್ ಆನ್ ಆಗಿದೆಯೇ ಎಂದು ಪರಿಶೀಲಿಸಿ.",
    micErrorMuted:
      "ನಾವು ನಿಮ್ಮ ಧ್ವನಿಯನ್ನು ಕೇಳಲು ಸಾಧ್ಯವಿಲ್ಲ! ನಿಮ್ಮ ಮೈಕ್ರೋಫೋನ್ ಆನ್ ಆಗಿದೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.",
    micErrorPermission:
      "ನಿಮ್ಮನ್ನು ಕೇಳಲು ನಮಗೆ ಅನುಮತಿ ಬೇಕು! ದಯವಿಟ್ಟು ಮೈಕ್ರೋಫೋನ್ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ.",
    micErrorGeneric: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ!",
    speakerError:
      "ನಾವು ಧ್ವನಿಯನ್ನು ಪ್ಲೇ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ! ನಿಮ್ಮ ಸ್ಪೀಕರ್ಗಳು ಆನ್ ಆಗಿದೆಯೇ ಎಂದು ಪರಿಶೀಲಿಸಿ!",
    speakerErrorGeneric: "ಓಹ್! ಧ್ವನಿ ಪ್ಲೇ ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ!",
    speakerErrorNoTest:
      "ನಾವು ನಿಮ್ಮ ಸ್ಪೀಕರ್ಗಳನ್ನು ಪರೀಕ್ಷಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ. ಅವು ಆನ್ ಆಗಿದೆಯೇ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ!",
    allTestsPassed: "ಎಲ್ಲಾ ಪರೀಕ್ಷೆಗಳು ಪಾಸ್! ನೀವು ಕಲಿಯಲು ಸಿದ್ಧರಾಗಿದ್ದೀರಿ!",
  },
  tn: {
    // Same as Tamil (ta) - alternative code
    listenAndRepeat: "வணக்கம்! ஆடியோவைக் கேட்டு மீண்டும் சொல்லுங்கள்!",
    nowRepeat: "இப்போது நீங்கள் கேட்டதை மீண்டும் சொல்லுங்கள்!",
    keepSpeaking: "நன்றாக! தொடர்ந்து பேசுங்கள்...",
    micTestPassed: "அருமை! நீங்கள் நன்றாக செய்தீர்கள்!",
    testMicrophone: "உங்கள் மைக்ரோஃபோனை சோதிக்கலாம்!",
    listenToVoice: "இப்போது உங்கள் குரலைக் கேட்போம்!",
    canYouHear: "நீங்கள் கேட்க முடிகிறதா?",
    speakerTestPassed: "சரியாக! நீங்கள் தயார்!",
    testSpeakers: "உங்கள் ஸ்பீக்கர்களை சோதிக்கலாம்!",
    clickToListen: "கேட்க கிளிக் செய்யவும்",
    clickToListenAgain: "மீண்டும் கேட்க கிளிக் செய்யவும்",
    playingAudio: "ஆடியோ இயங்குகிறது...",
    repeatNow: "இப்போது மீண்டும் சொல்லுங்கள்",
    tryAgain: "மீண்டும் முயற்சிக்கவும்",
    continue: "தொடரவும்",
    skip: "தவிர்க்கவும்",
    micErrorNoAudio:
      "உங்கள் குரலை நாங்கள் கேட்க முடியவில்லை! உங்கள் மைக்ரோஃபோன் இயக்கத்தில் உள்ளதா என்பதைச் சரிபார்க்கவும்।",
    micErrorMuted:
      "உங்கள் குரலை நாங்கள் கேட்க முடியவில்லை! உங்கள் மைக்ரோஃபோன் இயக்கத்தில் உள்ளது என்பதை உறுதிப்படுத்தவும்।",
    micErrorPermission:
      "உங்களைக் கேட்க எங்களுக்கு அனுமதி தேவை! தயவுசெய்து மைக்ரோஃபோன் அணுகலை அனுமதிக்கவும்।",
    micErrorGeneric: "ஏதோ தவறு நடந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
    speakerError:
      "ஒலியை இயக்க முடியவில்லை! உங்கள் ஸ்பீக்கர்கள் இயக்கத்தில் உள்ளதா என்பதைச் சரிபார்க்கவும்!",
    speakerErrorGeneric: "ஓ! ஒலி இயங்கவில்லை. மீண்டும் முயற்சிக்கவும்!",
    speakerErrorNoTest:
      "உங்கள் ஸ்பீக்கர்களை நாங்கள் சோதிக்க முடியவில்லை. அவை இயக்கத்தில் உள்ளதா என்பதை உறுதிப்படுத்தவும்!",
    allTestsPassed:
      "அனைத்து சோதனைகளும் தேர்ச்சி! நீங்கள் கற்றுக்கொள்ளத் தயார்!",
  },
};

/**
 * Get translations for a specific language
 * @param {string} lang - Language code (en, hi, ta, te, ka, kn, tn)
 * @returns {object} Translation object for the language, defaults to English
 */
export const getTranslations = (lang) => {
  // Handle language code aliases
  const langMap = {
    tn: "ta", // Map tn to ta (Tamil)
    kn: "ka", // Map kn to ka (Kannada)
  };

  const mappedLang = langMap[lang] || lang;
  return (
    AUDIO_DIAGNOSTIC_TRANSLATIONS[mappedLang] ||
    AUDIO_DIAGNOSTIC_TRANSLATIONS.en
  );
};
